import {connect} from "react-redux";
import SubscriptionsPage from "./SubscriptionsPage";
import * as ViewActions from "../actions/ViewActions";
import * as SubscriptionApiActions from "../actions/SubscriptionApiActions";
import {withRouter} from "react-router";

export default connect(null, {...ViewActions, ...SubscriptionApiActions})(withRouter(SubscriptionsPage));